export const PROFILE_STALE_TIME_MS = 5 * 60 * 1000;
export const PROFILE_GC_TIME_MS = 10 * 60 * 1000;
